import { RouteObject } from "../../interfaces/navigation";
import React from "react";

const EntryPoint = React.lazy(() => import("../../containers/PublicationsBrandPage/PublicationsBrandPageContainer"));

export const publicationsBrandRoutes: RouteObject[] = [
    {
        title: "Publication Redirect",
        path: "/:brandName/publicacion/:id",
        component: <EntryPoint />
    },
    {
        title: "Publication Redirect",
        path: "/:brandName/publication/:id",
        component: <EntryPoint />
    },
    {
        title: "Publication Redirect",
        path: "brands/:brandName/publication/:id",
        component: <EntryPoint />
    },
];